// utils/localizeLinks.ts
export function localizeHref(href: string, locale: string) {
  if (!href) {
    return href;
  }
  // don't touch external links, anchors or non-HTTP protocols (tel:, mailto:, sms:…)
  if (href.startsWith('http') || href.startsWith('#') || /^[a-z][a-z0-9+.-]*:/i.test(href)) {
    return href;
  }

  // already localized?
  if (href === `/${locale}` || href.startsWith(`/${locale}/`)) {
    return href;
  }

  // normalize
  const clean = href.startsWith('/') ? href.slice(1) : href;
  return `/${locale}/${clean}`;
}

/**
 * Recursively walk any slice object/array and localize common link fields.
 * You can extend the keys list if you use other names.
 */
export function localizeLinksInSlice<T = any>(node: T, locale: string): T {
  if (Array.isArray(node)) {
    return node.map((item) => localizeLinksInSlice(item, locale)) as unknown as T;
  }
  if (node && typeof node === 'object') {
    const keysToLocalize = new Set(['link', 'href', 'buttonHref', 'buttonUrl', 'ctaHref']);
    const out: any = Array.isArray(node) ? [] : { ...node };

    for (const [k, v] of Object.entries(node as any)) {
      if (typeof v === 'string' && keysToLocalize.has(k)) {
        out[k] = localizeHref(v, locale);
      } else {
        out[k] = localizeLinksInSlice(v, locale);
      }
    }
    return out;
  }
  return node;
}
